import { defineMessages } from 'react-intl';

/**
 * Warm-up phrases cycled by `ProjectThinkingIndicator` the instant a fresh
 * prompt lands, before the agent has any context to work with. Deliberately
 * generic, light clinical flavour.
 */
export const projectThinkingMessages = defineMessages({
  scrubbingIn: {
    defaultMessage: 'Scrubbing in',
    id: 'FMSCBGD5+q',
    description: 'Thinking indicator warm-up phrase (getting ready to start)',
  },
  preppingForRounds: {
    defaultMessage: 'Prepping for rounds',
    id: '2OdPETVfKr',
    description: 'Thinking indicator warm-up phrase (preparing)',
  },
  reviewingTheAsk: {
    defaultMessage: 'Reviewing the ask',
    id: 'sVrCf5ep9k',
    description: 'Thinking indicator warm-up phrase (reading the request)',
  },
  workingItUp: {
    defaultMessage: 'Working it up',
    id: '/1gkmC2W41',
    description: 'Thinking indicator warm-up phrase (processing the request)',
  },
});
